import { businessDate, reservationStatus } from './stock';

export function finishedReserved(reservations = [], variantId, showroomId, date = businessDate()) {
  return reservations.reduce((total, row) => total + (
    String(row.variant_id) === String(variantId) &&
    (showroomId == null || String(row.showroom_id) === String(showroomId)) &&
    reservationStatus(row, date) === 'active' ? Number(row.quantity) || 0 : 0), 0);
}

export function finishedAvailable(catalog, variantId, showroomId) {
  const physical = catalog.stocks.filter(row => String(row.variant_id) === String(variantId) &&
    (showroomId == null || String(row.showroom_id) === String(showroomId)))
    .reduce((sum, row) => sum + Number(row.quantity), 0);
  return Math.max(0, physical - finishedReserved(catalog.reservations, variantId, showroomId));
}
